import { render, staticRenderFns } from "./modal_supplier.vue?vue&type=template&id=22a6427d&"
import script from "./modal_supplier.vue?vue&type=script&lang=js&"
export * from "./modal_supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports